import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import type { Period, ReceiptMode } from './useSalesComparison';

interface Props {
    period: Period;
    current: boolean;
    receiptMode: ReceiptMode;
    onSelect: (period: Period, current: boolean) => void;
    onReceiptMode: (mode: ReceiptMode) => void;
}

export function SalesComparisonControls({ period, current, receiptMode, onSelect, onReceiptMode }: Props) {
    const choiceKey = `${period}-${current ? 'cur' : 'prev'}`;

    return (
        <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2, flexWrap: 'wrap' }}>
            <ToggleButtonGroup size="small" exclusive value={choiceKey}
                onChange={(_, value) => { if (value) { const [p, c] = value.split('-'); onSelect(p as Period, c === 'cur'); } }}>
                <ToggleButton value="week-cur">Innevarande vecka</ToggleButton>
                <ToggleButton value="week-prev">Föregående vecka</ToggleButton>
                <ToggleButton value="month-cur">Innevarande månad</ToggleButton>
                <ToggleButton value="month-prev">Föregående månad</ToggleButton>
            </ToggleButtonGroup>
            <ToggleButtonGroup size="small" exclusive value={receiptMode} onChange={(_, value) => value && onReceiptMode(value)}>
                <ToggleButton value="all">Alla köp</ToggleButton>
                <ToggleButton value="pos">Positiva köp</ToggleButton>
            </ToggleButtonGroup>
        </Stack>
    );
}
